import React from 'react';

export default class OptionInput extends React.Component {
    static MAX_COLLAPSED_ITEMS = 8;

    state = {
        open: false,
        value: this.props.value,
        gruppen: this.getGruppen(),
        toggleOpen: false
    };

    getGruppen() {
        const gruppen = _.orderBy(APP.getUsedGriffGruppen(), ['Anzeigereihenfolge'], ['asc']);
        return gruppen.map(gruppe=>({
            ...gruppe,
            toggleOpen: false,
            griffe: _.orderBy(this.props.options, ['Anzeigereihenfolge'], ['asc'])
        }));
    }

    clicked(value) {
        this.props.setValue(value, {next:false});
        this.setState({open: !this.props.autoclose, value: value})
    }

    close() {
        this.props.setValue(this.state.value, {next:true});
        this.setState({open: false})
    }

    bild(product) {
        const bild = product.Bild || "default.png";
        return SETTINGS.wkfgContentBaseUrl + bild;
    }

    render() {        
        return (
            <div className={"griff " + (this.props.hidden?"disappear":"appear")+' '+(this.state.open?'griff-open':'griff-closed')}>
                <div className="griff-input" onClick={() => this.setState({open: !this.state.open})}>
                    <label htmlFor="sample-input-1">{this.props.label}</label>
                    <div className="griff-select">
                        {this.state.open &&
                        <a className="button icon"><span
                            className="icon down"/></a>
                        }
                        {!this.state.open &&
                        <a className="button icon"><span
                            className="icon down"/></a>
                        }
                    </div>
                </div>
                {this.state.open &&
                <React.Fragment>
                    <div className="griff-list">
                    {this.props.options.map((option, index) =>(
                        (index < OptionInput.MAX_COLLAPSED_ITEMS || this.state.toggleOpen) && (
                            <div className="griff-stil" key={index}>
                                <div className="griff-stil-list">
                                    <h4 className="griff-label">
                                        {option.label}
                                        <div className="info" onClick={()=>APP.uiHandler.showHelpPopup(option)}></div>
                                    </h4>
                                    <div
                                        key={option.articlenumber}
                                        data-toggle="tooltip"
                                        data-key={option.key}
                                        data-placement="top"
                                        data-container="body"
                                        id={"korpus-" + option.articlenumber}
                                        className={this.props.withoutThumb ? "" : "griff-item dummyproduct stopselect"}
                                        data-decor-title={option.label}
                                        
                                        title={option.label}
                                        onClick={(option) => this.clicked(option.currentTarget.dataset.key)}
                                    ></div>
                                </div>
                            </div>
                        )
                    ))}
                    {this.props.options.length>OptionInput.MAX_COLLAPSED_ITEMS && (
                        <div className={"griff-collapse"}>
                            <a className="" onClick={() => {
                                this.state.toggleOpen = !this.state.toggleOpen;
                                this.setState(this.state);
                            }}>
                                {I18N(this.state.toggleOpen ? "Weniger" :  "Mehr")}...
                            </a>
                        </div>
                    )}
                    </div>
                </React.Fragment>
                }
            </div>
        )
    }

}
